const AU = {
  market: 'AU',
  inputs: {
    ZIP: {
      labelRef: 'POSTAL_CODE',
    },
  },
};
export default AU;
